import { SubHeader, SubHeaderActions } from '../../components/SubHeader';
import { AddMenu } from './AddMenu';

const displayContent = {
  pageTitle: 'Lists',
};

const PageActions = () => (
  <SubHeaderActions>
    <AddMenu />
  </SubHeaderActions>
);

export const ListHeader = () => (
  <SubHeader actions={<PageActions />}>{displayContent.pageTitle}</SubHeader>
);
